import { createPortal } from '@/features/common/contexts/Portal'

export const { Provider: ReprintModalPortalProvider, usePortal: useReprintModalPortal } =
    createPortal()
